import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import React, { useRef, useState } from "react";
import useCollapse from "react-collapsed";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import {
  DoActionRequest,
  DoActionResponse,
  GetCartableActionsResponse,
  GetCoreInformationResponse,
  GetSupplierInformationResponse,
} from "../../../../models/cartable.model";
import { ApiResultModel } from "../../../../models/common.model";
import {
  DoAction,
  GetAppInformation,
  GetCartableActions,
  GetCoreInformation,
  GetSupplierInformation,
} from "../../../../services/cartable.service";
import DynamicActionTab from "./dynamicActionTab";

export default function ActionTabsModifid(props: any) {
  const [tabs, setTabs] = React.useState(props.actionTabsData.tabs);
  const [openValidationModel, setOpenValidationModel] = React.useState(false);
  const queryClient = useQueryClient();
  const clickRef = useRef(null);
  const [inputsError, setInputsError] = useState(false);
  //***services detail */
  const getCoreInformationMutation = useMutation(GetCoreInformation, {
    onSuccess: (data: ApiResultModel<GetCoreInformationResponse>) => {
      if (data) {
        props.setDataGetCoreInformation(data.data);
        // history.push("/loan/SupplierSettlementCartable");
      }
    },
  });
  const getAppInformationMutation = useMutation(GetAppInformation, {
    onSuccess: (data: ApiResultModel<GetCoreInformationResponse>) => {
      if (data) {
        props.setDataGetCoreInformation(data.data);
        // history.push("/loan/SupplierSettlementCartable");
      }
    },
  });
  const getCartableActionsMutation = useMutation(GetCartableActions, {
    onSuccess: (data: GetCartableActionsResponse[]) => {
      if (data) {
        props.setDataGetCartableActions(data);
        // history.push("/loan/SupplierSettlementCartable");
      }
    },
  });

  //***services detail */
  const doActionMutation = useMutation(DoAction, {
    onSuccess: (data: DoActionResponse) => {
      if (props.getCartableAction === "SupplierRequirements") {
        GetSupplierInformationMutate({
          supplierId: Number(supplierId),
        });
      }
      getCartableActionsMutation.mutateAsync({
        workflowType: props.getCartableAction!,
        referenceKey: props.referenceKey ?? "",
      });
      if (data) {
        toast.success(" عملیات با موفقیت انجام شد.");
        props.closeModal();
        props.setShowActionBtns(false);
        props.setFlagActionTab(false);
        // props.setReload(true);

        if (
          props.getCartableAction == "SupplierSettlementCartable" ||
          props.getCartableAction == "LoanRegistrationBySupplier"
        ) {
          getCoreInformationMutation.mutateAsync({
            referenceKey: props.referenceKey,
          });
        } else if (props.getCartableAction == "CustomerRegistration") {
          getAppInformationMutation.mutateAsync({
            referenceKey: props.referenceKey,
          });
        }
      }
    },
  });
  const supplierId = localStorage.getItem("SUPPLIER_ID");
  const { mutate: GetSupplierInformationMutate } = useMutation(
    GetSupplierInformation,
    {
      onSuccess: (data: GetSupplierInformationResponse) => {
        if (data) {
          props.setDataGetCoreInformation(data);
          props.setReload(true);
          props.setShowActionBtns(false);
          props.closeModal();
        }
      },
      onError: () => {},
    }
  );
  let isRequired: any = [];
  const handelVerify = () => {
    let inputs: any = {};
    tabs.map((tab: any) => {
      tab.inputs.map((input: any) => {
        let name = input.name;
        let data = input.data;

        if (input.isRequired && !input.data) {
          const nameFeild = (
            <>
              <span dangerouslySetInnerHTML={{ __html: input.title }} />
              <br />
            </>
          );

          isRequired.push(nameFeild);
        }
        inputs[name] = data;
      });
    });

    let doAction = new DoActionRequest();
    doAction.referenceKey = props.referenceKey;
    //todo
    doAction.workflowType = props.getCartableAction!;
    doAction.workflowStepType = props.actionTabsData.workflowStepType;
    doAction.stepId = props.actionTabsData.stepId;
    doAction.inputs = inputs;
    if (props.referenceKey) {
      if (isRequired.length <= 0) {
        doActionMutation.mutate(doAction!);
      } else {
        // setOpenValidationModel(true);
        toast.error(
          <>
            <br />
            <b style={{ color: "red" }}>فیلدهای ضروری را پرکنید</b>
            <br />
            <span>{isRequired}</span>
          </>
        );
        setInputsError(true);
      }
    }
  };
  const handelCancel = () => {
    props.setFlagActionTab(false);
  };
  const [isExpanded, setExpanded] = useState(true);
  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });
  function handelCollapse() {
    setExpanded(!isExpanded);
  }

  return (
    <Box
      sx={{
        margin: "1.9vh",
        direction: "rtl",
        overflowX: "none",
        // border: "2px solid #E57373",
        // border:
        //   props.actionTabsData.workflowStepType.toLowerCase() === "forward"
        //     ? "2px solid green"
        //     : "2px solid #E57373",
      }}
    >
      <div
        // className="boxView  borderCOlor"
        style={{ background: "#FFF" }}
      >
        {/* <div
          onClick={handelCollapse}
          style={{
            backgroundColor: "#E57373",
            height: "4vh",
            marginBottom: "-1.4vh",
            marginRight: "-11px",
            marginLeft: "-11px",
            marginTop: "-11px",
          }}
          className="centerVertical"
        >
          <span
            style={{
              backgroundColor: "#E57373",
              color: "#fff",
              fontSize: "16px",
              marginRight: "2vh",
            }}
          >
            <NotificationImportantOutlinedIcon />
            {props.actionTabsData.header}
          </span>
          {isExpanded ? (
            <ArrowDropUpIcon style={{ color: "#fff" }} />
          ) : (
            <ArrowDropDownIcon style={{ color: "#fff" }} />
          )}
        </div> */}
        <section {...getCollapseProps()}>
          {/* <br />
          <br /> */}
          {/* <hr /> */}
          {/* <CardHintCmp title={props.actionTabsData.description} /> */}
          {props.actionTabsData.tabs.length > 0 ? (
            <DynamicActionTab
              inputsError={inputsError}
              tabs={tabs}
              setTabs={setTabs}
              color={
                props.actionTabsData.workflowStepType.toLowerCase() ===
                "forward"
                  ? "#01AF43"
                  : "#E57373"
              }
            />
          ) : null}
          <Grid
            container
            spacing={1}
            // columns={{ xs: 4, sm: 6, md: 12 }}
            className="mTop20 mbottom5"
            // style={{ justifyContent: "end" }}
            justifyContent={props.actionTabsData.showAsModal ? "center" : "end"}
          >
            <Grid
              item
              xs={8}
              sm={4}
              md={8}
              lg={props.actionTabsData.showAsModal ? 0 : 8}
              style={{ paddingRight: "2vh" }}
              className="confirmBottom"
            ></Grid>

            <Grid
              item
              xs={2}
              sm={4}
              md={2}
              lg={props.actionTabsData.showAsModal ? 6 : 2}
              style={{ paddingRight: "2vh" }}
              className="confirmBottom"
            >
              <Button
                onClick={handelVerify}
                fullWidth
                className={`btnForm 
                    ${
                      props.actionTabsData.workflowStepType.toLowerCase() ===
                      "backward"
                        ? "DangerDefault"
                        : "SuccessDefault"
                    }`}
                style={{ fontSize: "11px !important", whiteSpace: "nowrap" }}
              >
                {props.actionTabsData.action}
              </Button>
            </Grid>
            <Grid
              item
              xs={2}
              sm={4}
              md={2}
              style={{ paddingRight: "2vh" }}
              lg={props.actionTabsData.showAsModal ? 6 : 2}
              className="confirmBottom"
            >
              <Button
                // onClick={handelCancel}
                onClick={() => {
                  props.closeModal();
                }}
                fullWidth
                className="btnForm ComingBack "
                style={{ fontSize: "11px !important", whiteSpace: "nowrap" }}
              >
                بازگشت
              </Button>
            </Grid>
          </Grid>
        </section>
      </div>
      {/* <ModalCmp
        openModel={openValidationModel}
        validationMessages={isRequired}
        firstPartOfTitle=" درخواست تسهیلات به دلایل زیر"
        boldTitle="پذیرفته"
        secondPartOfTitle="نشد:"
      /> */}
    </Box>
  );
}
